import { render } from "./StockColisPage.vue?vue&type=template&id=877e671e&ts=true"
import script from "./StockColisPage.vue?vue&type=script&lang=ts"
export * from "./StockColisPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__